import { ActionTypes } from "../../constants/ActionTypes";
import { ICommonState } from "../../interfaces";

const INIT_STATE: ICommonState = {
  error: "",
  loading: false,
  message: "",
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_START: {
      return { ...state, error: "", message: "", loading: true };
    }

    case ActionTypes.FETCH_SUCCESS: {
      return { ...state, error: "", message: "", loading: false };
    }

    case ActionTypes.SHOW_MESSAGE: {
      return { ...state, error: "", message: action.payload, loading: false };
    }

    case ActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, error: action.payload, message: "" };
    }

    case ActionTypes.HIDE_MESSAGE: {
      return { ...state, loading: false, error: "", message: "" };
    }

    default:
      return state;
  }
};
